export default "__VITE_ASSET__Chujh_p5__"